//Don't change the order!!!
export const NEW_ORDER = {
  id: 0,
  value: "newOrders",
  label: "New Order",
  color: "#FFC830" //yellow
};
export const CANCELLED = {
  id: 1,
  value: "cancelled",
  label: "Cancelled",
  color: "#FF654E" //red
};
export const COMPLETED = {
  id: 2,
  value: "completed",
  label: "Completed",
  color: "#28D484" //green
};
export const PREPARING = {
  id: 3,
  value: "preparing",
  label: "Preparing",
  color: "#FFC830" //yellow
};
export const READY_FOR_DELIVERY = {
  id: 4,
  value: "readyForDelivery",
  label: "Ready For Delivery",
  color: "#FFC830" //yellow
};
export const PICKED_UP = {
  id: 5,
  value: "pickedUp",
  label: "Picked Up ",
  color: "#28D484" //green
};

export const STATUSES = [
  NEW_ORDER,
  CANCELLED,
  COMPLETED,
  PREPARING,
  READY_FOR_DELIVERY,
  PICKED_UP
];
export const SECTIONS = [
  {
    title: NEW_ORDER.label,
    status: NEW_ORDER.value,
    badgeColor: ""
  },
  {
    title: PREPARING.label,
    status: PREPARING.value,
    badgeColor: "#FF6B28"
  },
  {
    title: READY_FOR_DELIVERY.label,
    status: READY_FOR_DELIVERY.value,
    badgeColor: "#0981FF"
  },
  {
    title: PICKED_UP.label,
    status: PICKED_UP.value,
    badgeColor: "#F22D2D"
  }
];
